/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useContext, useEffect, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { ModalLost, ModalCancelEndorsement } from 'components/index';
import Button from 'components/Button';
import { useHistory } from 'react-router-dom';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';

function LostCancelButton(props) {
  const [modalLostOpen, setModalLostOpen] = useState(false);
  const [modalCancelationOpen, setmodalCancelationOpen] = useState({ visible: false });
  const [isEndorsement, setIsEndorsement] = useState(false);
  const [shouldRenderAnyButton, setShouldRenderAnyButton] = useState(true);

  const history = useHistory();

  const authContext = useContext(GlobalAuthContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.idOperation)
      .then(response => response.json())
      .then(response => {
        if (response.idDomain !== 26) setIsEndorsement(true)
        if (response.isBound) setShouldRenderAnyButton(false)
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  useEffect(() => {
    getOperationInfo()
  }, [])

  const renderButton = () => {
    if (shouldRenderAnyButton && isEndorsement) {
      return (
        <Button
          type="button"
          secundary
          onClick={() => {
            setmodalCancelationOpen({ visible: true })
          }}
        >
          CANCEL
        </Button>
      )
    }

    if (shouldRenderAnyButton && !isEndorsement) {
      return (
        <Button
        style={{width: '100%'}}
          type="button"
          secundary
          onClick={() => {
            setModalLostOpen(true)
          }}
        >
          LOST
        </Button>
      )
    }

    return <div />
  }

  return (
    <div>
      <ModalCancelEndorsement
        history={history}
        show={modalCancelationOpen.visible}
        setDialog={setmodalCancelationOpen}
        idOperation={props.idOperation}
        screen={props.screen}
      />

      <ModalLost
        idOperation={props.idOperation}
        show={modalLostOpen}
        setDialog={setModalLostOpen}
        history={history}
      />

      {renderButton()}

    </div>
  );
}

const propTypes = {
  isEndorsement: PropTypes.bool,
}

LostCancelButton.prototype = propTypes;
export default LostCancelButton;